import { TextField, MenuItem } from "@mui/material";
import DisplayTextField from "../DisplayTextField";

const PrescriptionMedicationFieldForObjectState = ({
  formInfo,
  Object,
  handleChange,
}) => {
  let name = Object.name;
  let Page = Object.Page;

  let Array = [
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Prescription",
      name: name + "medication",
      selectValues: [
        "EpiPen, (an epinephrine autoinjector)",
        "Other lifesaving medication",
        "Prescribed medication (not lifesaving)",
        "No, the student does not have any prescribed medication for this allergy",
      ],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: (
        <p>
          Please specify the life-saving or reactive medication if they interact
          with the allergen?
        </p>
      ),
    },
    {
      Page: Page,

      TextField: "TextFieldForObjectState",
      label: "EpiPen brand name",
      name: name + "epipen_brand_name",
      onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "medication",
      AboveText: <p>Please specify the EpiPen brand name</p>,
    },

    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Dosage",
      name: name + "epipen_dosage",
      onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "medication",
      AboveText: (
        <p>What is the dosage in the EpiPen for the student? (e.g. 0.3mg)</p>
      ),
    },
    {
      Page: Page,
      TextField: "MultiSelectFieldForObjectState",
      label: "Carrying EpiPen",
      name: name + "epipen_bringing ",
      selectValues: [
        {
          name: name + "epipen_always_carry",
          label: "Yes, the student will always carry their EpiPen at all times",
        },
        {
          name: name + "epipen_bring_spare",
          label: "Yes, the student will bring a spare EpiPen",
        },
        {
          name: name + "epipen_bring_no_spare",
          label: "The student is unable to bring a spare EpiPen",
        },
      ],
      onlyAppearIfValueIs: ["EpiPen, (an epinephrine autoinjector)"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "medication",
      SpecialCondition: "Optional",
      AboveText: (
        <p>
          Ensure the EpiPen is in date, and confirm below that the student will
          carry it with them at all times. InvestIN strongly recommends that the
          student brings a spare EpiPen with them, please confirm if this is
          possible .{" "}
        </p>
      ),
    },
    //Prescribed/Other Meds
    {
      Page: Page,
      TextField: "MedicationFieldForObjectState",
      label: "Name of medication",
      name: name,
      onlyAppearIfValueIs: [
        "Prescribed medication (not lifesaving)",
        "Other lifesaving medication",
      ],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "medication",
    },
  ];

  return (
    <>
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[0]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[1]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[2]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[3]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[4]}
      />
    </>
  );
};

export default PrescriptionMedicationFieldForObjectState;
